export default {
	CHANGE_HEAD: 'CHANGE_HEAD',

	HEAD_CHANGE_LANGUAGE: 'HEAD_CHANGE_LANGUAGE',
	HEAD_CHECK_LANGUAGE: 'HEAD_CHECK_LANGUAGE',
	FETCH_LANGUAGE: 'FETCH_LANGUAGE',
	FETCH_LANGUAGE_FILES: 'FETCH_LANGUAGE_FILES',
	NAVIGATION_CHANGE: 'NAVIGATION_CHANGE',

	CONSET_TO_COOKIE: 'CONSET_TO_COOKIE',
	CHECK_CONSENT: 'CHECK_CONSENT',

	SET_CMS_HEAD: 'SET_CMS_HEAD',
	CHANGE_SOCIAL_MEDIA: 'CHANGE_SOCIAL_MEDIA_VISIBILITY',
};



// WEBPACK FOOTER //
// ./src/redux/head/actionTypes.js